<div id="dashboard-project" class="page-layout simple right-sidebar" fxLayout="row">

    <!-- CENTER -->
    <div class="center" fusePerfectScrollbar>

        <!-- HEADER -->
        <div class="header primary p-24 pb-0" fxLayout="column" fxLayoutAlign="space-between">

            <div fxLayout="row" fxLayoutAlign="space-between start">

                <span class="mat-display-1 my-0 my-sm-24 welcome-message"
                    [@animate]="{value:'*',params:{x:'50px'}}">{{'FIRMWARE_PACKET_LIST' | translate}}
                </span>
            </div>
        </div>
        <!-- / HEADER -->
        <div class="content-card" style="justify-content: space-between;">
            <div class="p-20">
                <mat-table style="border-radius: 10px 10px 0px 0px;" #table [dataSource]="dataSource" matSort
                    [@animateStagger]="{value:'50'}"  matSortActive="rowNum" matSortDirection="asc" fusePerfectScrollbar>
    
                    <!--PNo Column -->
                    <ng-container class="packet-table-no" matColumnDef="rowNum">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>PNo</mat-header-cell>
                        <mat-cell mat-cell *matCellDef="let firmware">
                            {{firmware.rowNum}}
                        </mat-cell>
                    </ng-container>
    
                    <!-- Packet Column -->
                    <ng-container matColumnDef="packet">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>{{'PACKET' | translate}}</mat-header-cell>
                        <mat-cell class="packet-table-name" *matCellDef="let firmware">
                            <textarea matInput [value]="firmware.row"></textarea>
                        </mat-cell>
                    </ng-container>
                    <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>
                    <mat-row *matRowDef="let firmware; columns: displayedColumns;" class="order" matRipple>
                    </mat-row>
                </mat-table>
                <mat-paginator #paginator [length]="paginator.length" [pageSize]="10" [pageSizeOptions]="[10, 50, 100]">
                </mat-paginator>
            </div>
        </div>
    </div>
    <!-- / CENTER -->
</div>